import { ExclamationCircleFilled, WarningOutlined } from '@ant-design/icons'
import { BBDTag, GraviButton, GraviGrid, NothingMessage, Texto } from '@gravitate-js/excalibrr'
import { AgGridColumn } from 'ag-grid-react'
import { Space } from 'antd'
import React, { useMemo } from 'react'

export function StatusMessageGrid({ statusView, setStatusView, statusResponse }) {
  const rowData = statusView && statusView === 'error' ? statusResponse.errors : statusResponse.warnings
  const showGrid = statusResponse.error_count + statusResponse.warning_count !== 0
  const showMessage = statusResponse.error_count + statusResponse.warning_count + statusResponse.updated_count === 0
  if (showMessage) {
    return (
      <NothingMessage
        title='No Results Updated'
        message='No results were uploaded. Please check your sheet and try again.'
      />
    )
  }
  const agPropOverrides = useMemo(
    () => ({
      columnDefaultOverrides: {
        resizeable: false,
        flex: undefined,
      },
      rowHeight: 25,
      headerHeight: 25,

      alwaysShowHorizontalScroll: true,
      getRowId: (params) => `${params?.data?.row_number}-${params?.data?.message}`,
    }),
    []
  )

  const columnDefs = useMemo(() => {
    return [
      {
        field: 'row_number',
        headerName: 'row number',
        cellRenderer: ({ value }) => <RowNumberCellRenderer value={value} status={statusView} />,
        width: '150',
      },
      {
        field: 'message',
        headerName: 'message',
        cellRenderer: ({ value }) => <MessageCellRenderer value={value} status={statusView} />,
        flex: 1,
      },
    ]
  }, [])

  if (showGrid) {
    return (
      <div style={{ height: 350 }}>
        <GraviGrid
          controlBarProps={{
            title: statusView === 'error' ? 'Error(s)' : 'Warning(s)',
            actionButtons: (
              <ActionButtons
                statusView={statusView}
                setStatusView={setStatusView}
                errorCount={statusResponse.error_count}
                warningCount={statusResponse.warning_count}
              />
            ),
          }}
          rowHeight={25}
          agPropOverrides={agPropOverrides}
          rowData={rowData}
          columnDefs={columnDefs}
        />
      </div>
    )
  }
  return null
}
function ActionButtons({ statusView, setStatusView, errorCount, warningCount }) {
  return (
    <div className='flex items-center'>
      <Space>
        <GraviButton
          onClick={() => {
            setStatusView('warning')
          }}
          warning={statusView === 'warning'}
          buttonText={`Warnings (${warningCount})`}
          disabled={warningCount < 1}
        />
        <GraviButton
          onClick={() => {
            setStatusView('error')
          }}
          error={statusView === 'error'}
          buttonText={`Errors (${errorCount})`}
          disabled={errorCount < 1}
        />
      </Space>
    </div>
  )
}
function RowNumberCellRenderer(count) {
  return (
    <div>
      {count.status === 'error' ? (
        <Space>
          <ExclamationCircleFilled style={{ color: 'var(--theme-error)' }} />
          <BBDTag className='text-uppercase' error>
            {count && count.value}
          </BBDTag>
        </Space>
      ) : (
        <Space>
          <WarningOutlined style={{ color: 'var(--theme-warning)' }} />
          <BBDTag className='text-uppercase' style={{ textTransform: 'uppercase' }} warning>
            {count && count.value}
          </BBDTag>
        </Space>
      )}
    </div>
  )
}
function MessageCellRenderer(message) {
  return (
    <>
      {message.status === 'error' ? (
        <Texto appearance='error' weight='bold'>
          {message && message.value}
        </Texto>
      ) : (
        <Texto appearance='warning' weight='bold'>
          {message && message.value}
        </Texto>
      )}
    </>
  )
}
